function ruleName(rule) {
  var _a;
  return (_a = rule.title) != null ? _a : rule.expression;
}
var ExemptionStatusResponseType = /* @__PURE__ */ ((ExemptionStatusResponseType2) => {
  ExemptionStatusResponseType2["PENDING"] = "PENDING";
  ExemptionStatusResponseType2["APPROVED"] = "APPROVED";
  ExemptionStatusResponseType2["REJECTED"] = "REJECTED";
  return ExemptionStatusResponseType2;
})(ExemptionStatusResponseType || {});
var RuleOutcomeType = /* @__PURE__ */ ((RuleOutcomeType2) => {
  RuleOutcomeType2["APPLICABLE"] = "APPLICABLE";
  RuleOutcomeType2["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  RuleOutcomeType2["NOT_EVALUATED"] = "NOT_EVALUATED";
  return RuleOutcomeType2;
})(RuleOutcomeType || {});
var GroupByOption = /* @__PURE__ */ ((GroupByOption2) => {
  GroupByOption2["ENTITY"] = "Entity";
  GroupByOption2["TEAM"] = "Team";
  GroupByOption2["SERVICE_GROUP"] = "Service Group";
  GroupByOption2["LEVEL"] = "Level";
  GroupByOption2["DOMAIN"] = "Domain";
  return GroupByOption2;
})(GroupByOption || {});
var OwnerInheritance = /* @__PURE__ */ ((OwnerInheritance2) => {
  OwnerInheritance2["Append"] = "APPEND";
  OwnerInheritance2["Fallback"] = "FALLBACK";
  OwnerInheritance2["None"] = "NONE";
  return OwnerInheritance2;
})(OwnerInheritance || {});
var InitiativeScheduleTimeUnit = /* @__PURE__ */ ((InitiativeScheduleTimeUnit2) => {
  InitiativeScheduleTimeUnit2["Day"] = "DAY";
  InitiativeScheduleTimeUnit2["Month"] = "MONTH";
  InitiativeScheduleTimeUnit2["Week"] = "WEEK";
  return InitiativeScheduleTimeUnit2;
})(InitiativeScheduleTimeUnit || {});
var Permission = /* @__PURE__ */ ((Permission2) => {
  Permission2["EDIT_SETTINGS"] = "EDIT_SETTINGS";
  return Permission2;
})(Permission || {});
var JobStatus = /* @__PURE__ */ ((JobStatus2) => {
  JobStatus2["InProgress"] = "IN_PROGRESS";
  JobStatus2["Done"] = "DONE";
  JobStatus2["Cancelled"] = "CANCELLED";
  JobStatus2["Failure"] = "FAILURE";
  JobStatus2["TimedOut"] = "TIMED_OUT";
  return JobStatus2;
})(JobStatus || {});
var ContractType = /* @__PURE__ */ ((ContractType2) => {
  ContractType2["Production"] = "PRODUCTION";
  ContractType2["Trial"] = "TRIAL";
  return ContractType2;
})(ContractType || {});
var CategoryFilter = /* @__PURE__ */ ((CategoryFilter2) => {
  CategoryFilter2["Domain"] = "Domain";
  CategoryFilter2["Resource"] = "Resource";
  CategoryFilter2["Service"] = "Service";
  CategoryFilter2["Team"] = "Team";
  return CategoryFilter2;
})(CategoryFilter || {});
var FilterType = /* @__PURE__ */ ((FilterType2) => {
  FilterType2["COMPOUND_FILTER"] = "COMPOUND_FILTER";
  FilterType2["CQL_FILTER"] = "CQL_FILTER";
  FilterType2["DOMAIN_FILTER"] = "DOMAIN_FILTER";
  FilterType2["RESOURCE_FILTER"] = "RESOURCE_FILTER";
  FilterType2["SERVICE_FILTER"] = "SERVICE_FILTER";
  FilterType2["TEAM_FILTER"] = "TEAM_FILTER";
  return FilterType2;
})(FilterType || {});

export { CategoryFilter, ContractType, ExemptionStatusResponseType, FilterType, GroupByOption, InitiativeScheduleTimeUnit, JobStatus, OwnerInheritance, Permission, RuleOutcomeType, ruleName };
//# sourceMappingURL=types.esm.js.map
